import React from 'react';
import classNames from 'classnames';

import Button from 'rebook/apps/base/components/Button';
import formatCurrency from 'rebook/apps/utils/text/formatCurrency';

import styles from './style.scss';


const PaymentsActionButton = ({
  price, fullPrice, isPro,
  isSurcharge, extraClassName, url,
  text, theme, isProSubscriberBuysAudioSubscription,
  isOfferText,
}) => (
  <Button extraClassName={classNames(
    styles.subscriptionButton,
    { [styles.subscriptionButtonStandard]: !isPro },
    extraClassName
  )}
  theme={theme || 'primary'}
  onClick={() => (yaMetrikaReachGoal('Upgrade'))}
  url={url} >
    <div className={styles.subscriptionButtonLabel}>
      <div className={classNames(styles.subscriptionButtonLabelTitle, isOfferText && styles.isOfferText)}>
        {text && (
          <span>{text}</span>
        )}
        {(isProSubscriberBuysAudioSubscription || (isSurcharge && !isProSubscriberBuysAudioSubscription)) && (
          <span>С вашей скидкой&nbsp;</span>
        )}
        {(!isProSubscriberBuysAudioSubscription && !isSurcharge && !text) && (
          <span>1 месяц&nbsp;</span>
        )}
        <span>
          {isSurcharge && (fullPrice < price) && (
            <span className={styles.subscriptionButtonFullPrice}>{formatCurrency(fullPrice, 'RUB')}</span>
          )}
          {price
            ? formatCurrency(price, 'RUB')
            : ''
          }
        </span>
      </div>
    </div>
  </Button>
);

export default PaymentsActionButton;

